'use client';

import React from 'react';
import { useMediaQuery } from 'usehooks-ts';
import styles from './ServiceAndMaintenanceHero.module.scss';

const Hero = ({ heroSectionData }) => {
  const isTablet = useMediaQuery('(max-width: 834px)');
  const isMobile = useMediaQuery('(max-width: 480px)');

  const getImageUrl = (imageField) => {
    if (!imageField?.fields) return '';

    const getImageUrlFromField = (field) => {
      if (!field?.value?.src) return '';
      return field.value.src;
    };

    if (isMobile) {
      return (
        getImageUrlFromField(imageField.fields.mobileImage) ||
        getImageUrlFromField(imageField.fields.tabletImage) ||
        getImageUrlFromField(imageField.fields.desktopImage) ||
        ''
      );
    }

    if (isTablet) {
      return (
        getImageUrlFromField(imageField.fields.tabletImage) ||
        getImageUrlFromField(imageField.fields.desktopImage) ||
        ''
      );
    }

    return getImageUrlFromField(imageField.fields.desktopImage) || '';
  };

  const imageField = heroSectionData?.image;
  const imageUrl = getImageUrl(imageField);
  const titleContent = heroSectionData?.title || '';

  return (
    <div className={styles.wrapper} data-aos="fade-up" data-aos-offset="100">
      {imageUrl && <img src={imageUrl} alt="Hero background" className={styles.backgroundImage} />}
      {titleContent && <div dangerouslySetInnerHTML={{ __html: titleContent }} />}
    </div>
  );
};

export default Hero;
